/// <reference path="../../../.tmp/typings/tsd.d.ts" />
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LoadingModal;
function LoadingModal() {
    return {
        template: '<h1>{{ vm.title }} <hmy-loading-spinner class="active white"></hmy-loading-spinner></h1>',
        restrict: 'E',
        require: ['hmyLoadingModal', '^^hmyModal'],
        scope: {},
        controller: LoadingModalController,
        controllerAs: 'vm',
        bindToController: true,
        link: function (scope, element, attrs, _a) {
            var vm = _a[0], parentCtrl = _a[1];
            parentCtrl.decorateChild(vm);
            parentCtrl.resolveReadyPromise(vm);
            vm.setDismissable(false);
        }
    };
}
var LoadingModalController = (function () {
    function LoadingModalController($element) {
        this.$element = $element;
        this.title = 'Processing';
    }
    return LoadingModalController;
}());
LoadingModalController.$inject = ['$element'];



//////////////////
// WEBPACK FOOTER
// ./src/components/loadingmodal/loadingmodal.directive.ts
// module id = 8
// module chunks = 0